import TicketService from "@/services/TicketService";

export const ticket = {
  namespaced: true,
  state: {
    ticket: {},
  },
  actions: {
    getTicket({ commit }, payload) {
      return TicketService.GetTicket(payload).then(
        (ticket) => {
          return Promise.resolve(ticket);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    postTicket({ commit }, payload) {
      return TicketService.PostTicket(payload).then(
        (ticket) => {
          return Promise.resolve(ticket);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    putTicket({ commit }, payload) {
      return TicketService.PutTicket(payload).then(
        (ticket) => {
          return Promise.resolve(ticket);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    deleteTicket({ commit }, payload) {
      return TicketService.DeleteTicket(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getTicketOData({ commit }, payload) {
      return TicketService.GetTicketOData(payload).then(
        (ticket) => {
          return Promise.resolve(ticket);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ticket;
